
import { defineComponent, computed } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
const { useGetters: useBulkActionsGetters } = createNamespacedHelpers('bulk-actions')
const { useActions: useBulkActions } = createNamespacedHelpers('bulk-actions')
import IconBtn from './IconBtn.vue'

// TODO Decouple from state
// Bulk Action Bar component that accepts its core content (buttons/selects/icons etc) via slot.
// It has a corresponding 'bulk-actions' vuex module, which need to be imported in the project for the component to work correctly
// Example usage: vue/product-library/src/components/ProductBulkActionBar.vue
export default defineComponent({
  name: 'BulkActionBar',
  props: {
    // Name of the resource, for example "product". Referenced in text: "X [resource]s selected".
    resource: {
      type: String,
      default: ''
    },
    // Items to select on "Select All" action
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    // SelectedIds represent a model of which items (ids) are selected. You can use "selectItem" and "unselectItem" actions
    // from `bulk-actions` store to modify this array (passing item id as an argument)
    // Components interacting with BulkActionBar can use selectedIds as source of truth to sync their own local state, such as whether element(s) should be selected
    // (see product-library/src/components/ProductList.vue for a list example or product-library/src/components/ProductCard.vue for a single card example)
    const { selectedIds } = useBulkActionsGetters(['selectedIds'])
    const { selectAll, unselectAll } = useBulkActions(['selectAll', 'unselectAll'])

    function toggleAllItems(val: boolean) {
      if (val) selectAll(props.items)
      else unselectAll()
    }

    const allItemsSelected = computed(() => {
      return selectedIds.value.length === props.items.length
    })

    const someItemsSelected = computed(() => {
      return selectedIds.value.length > 0 && !allItemsSelected.value
    })

    return {
      selectedIds,
      toggleAllItems,
      unselectAll,
      someItemsSelected,
      allItemsSelected
    }
  },
  components: {
    IconBtn
  }
})
